import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e621c73a")

_pushScopeId("data-v-e621c73a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 患者情報変更、削除 ")
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("(非表示にすると、予約画面、カルテ画面で患者が非表示になります。) ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_back_button = _resolveComponent("back-button")
  const _component_vue_title = _resolveComponent("vue-title")
  const _component_PatientSearchForm = _resolveComponent("PatientSearchForm")
  const _component_patient_list = _resolveComponent("patient-list")
  const _component_vue_two_column_content = _resolveComponent("vue-two-column-content")
  const _component_vue_content_remain = _resolveComponent("vue-content-remain")
  const _component_confirm = _resolveComponent("confirm")
  const _component_vue_frame = _resolveComponent("vue-frame")

  return (_openBlock(), _createBlock(_component_vue_frame, null, {
    default: _withId(() => [
      _createVNode(_component_vue_title, null, {
        default: _withId(() => [
          _createVNode("h2", null, [
            _createVNode(_component_back_button),
            _hoisted_1
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_vue_content_remain, null, {
        default: _withId(() => [
          _createVNode(_component_vue_two_column_content, null, {
            left: _withId(() => [
              _createVNode(_component_PatientSearchForm)
            ]),
            right: _withId(() => [
              _createVNode(_component_patient_list, {
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChange($event))),
                onHide: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onHide($event))),
                onShow: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onShow($event))),
                onDelete: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onDelete($event)))
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_confirm, {
        ref: "hideConfirmRef",
        onYes: _ctx.yesHide
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedPatientName) + "(" + _toDisplayString(_ctx.selectedPatientRead) + ") 様を非表示にしていいですか？", 1),
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "showConfirmRef",
        onYes: _ctx.yesShow
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedPatientName) + "(" + _toDisplayString(_ctx.selectedPatientRead) + ") 様を表示にしていいですか？ ", 1)
        ]),
        _: 1
      }, 8, ["onYes"]),
      _createVNode(_component_confirm, {
        ref: "deleteConfirmRef",
        onYes: _ctx.yesDelete
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.selectedPatientName) + "(" + _toDisplayString(_ctx.selectedPatientRead) + ") 様の情報を削除していいですか？ ", 1)
        ]),
        _: 1
      }, 8, ["onYes"])
    ]),
    _: 1
  }))
})